// Runtime configuration loaded from /public/config.js.
//
// The file is included as a regular <script> tag in public/index.html and
// declares the global window.__APP_CONFIG. This approach (instead of
// fetching config.json) works both when the app is served from a web
// server and when index.html is opened directly from disk via file://,
// which browsers disallow for XHR/fetch requests on local files.
//
// If the file is missing or malformed, the app falls back to DEFAULTS so
// it stays functional; the error is logged to the console. All fallback
// values live in src/service/constants.js to keep defaults in one place.
import { JSON_PATH } from './constants';

const DEFAULTS = {
    JSON_PATH,
};

let config = { ...DEFAULTS };

/**
 * Read window.__APP_CONFIG and populate the module-level config.
 * Returns a Promise for API consistency with previous fetch-based version,
 * but resolves synchronously because the data is available as soon as the
 * corresponding <script> tag has executed (before this module runs).
 */
export const loadConfig = async () => {
    try {
        const data = typeof window !== 'undefined' ? window.__APP_CONFIG : null;
        if (data && typeof data === 'object') {
            config = { ...DEFAULTS, ...data };
        } else {
            console.warn('config - window.__APP_CONFIG is not set, using defaults');
            config = { ...DEFAULTS };
        }
    } catch (err) {
        console.error('config - failed to read window.__APP_CONFIG, using defaults:', err);
        config = { ...DEFAULTS };
    }
};

/**
 * Synchronous access to the currently loaded configuration.
 * Safe to call from any component after loadConfig() has resolved.
 */
export const getConfig = () => config;
